import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../AccessoriesPage/Accessories.scss";
import Header from "../Sharedcomponents/Header/Header";
import dotimg from "../assets/bgdotimage.png";
import { LuDot } from "react-icons/lu";
import { Dropdown } from "primereact/dropdown";
import { IoMdArrowDropdown } from "react-icons/io";
import { InputText } from "primereact/inputtext";
import { IoCloseOutline } from "react-icons/io5";
import { Paginator } from "primereact/paginator";
import Footer from "../Component/Footer";
import { BookSlot } from "../RegistrationForm/BookSlot";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import Marquee from "react-fast-marquee";
import {
  getProductsByShopName,
  getAnnouncebyTag,
} from "../Services/BackendUrl";
import axios from "axios";

const Accessories = () => {
  const imgageRefs = useRef([]);
  const location = useLocation();
  const branchName = location.state?.branch || "kosmosruwibranch";
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(6);
  const [selectProduct, setSelectedProduct] = useState();
  const [showBrand, setShowbrand] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState("ALL");
  const [productsData, setProductsData] = useState([]);
  const [products, setProducts] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [announcementMessage, setAnnouncementMessage] = useState([]);
  const productContainerRef = useRef(null);
  const apiUrl = getProductsByShopName(branchName);
  const bgColorCycle = ["#FFD9A2", "#FFF195", "#CEE9FF"];
  const selectedCategoryName =
    selectProduct?.name === "ALL" || !selectProduct
      ? "ALL"
      : selectProduct?.name;

  const onShowbrand = (brandName) => {
    setSelectedBrand(brandName);
    setShowbrand(true);

    const result = [];

    products?.categories?.forEach((category) => {
      if (
        selectedCategoryName === "ALL" ||
        category.categoryName === selectedCategoryName
      ) {
        category.brands.forEach((brand) => {
          if (brandName === "ALL" || brand.brandName === brandName) {
            result.push(...brand.products);
          }
        });
      }
    });

    setProductsData(result);
    setTimeout(() => {
      productContainerRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const [items, setItems] = useState([{ name: "ALL" }]);
  useEffect(() => {
    const fetchBranchData = async () => {
      try {
        const response = await axios.get(apiUrl);
        setProducts(response.data || "");

        const fetchedCategories = response.data.categories || [];

        const categoryNames = fetchedCategories.map((cat) => ({
          name: cat.categoryName,
        }));
        const uniqueCategoryNames = [
          ...new Map(categoryNames.map((item) => [item.name, item])).values(),
        ];

        setItems([{ name: "ALL" }, ...uniqueCategoryNames]);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchBranchData();
  }, [apiUrl, branchName]);

  const getBrandsWithCounts = (categories, selectedCategory = "ALL") => {
    const brandMap = new Map();
    let totalCount = 0;

    categories.forEach((category) => {
      if (
        selectedCategory === "ALL" ||
        !selectedCategory ||
        category.categoryName === selectedCategory
      ) {
        category.brands.forEach((brand) => {
          const currentCount = brand.products.length;
          totalCount += currentCount;

          if (!brandMap.has(brand.brandName)) {
            brandMap.set(brand.brandName, currentCount);
          } else {
            brandMap.set(
              brand.brandName,
              brandMap.get(brand.brandName) + currentCount
            );
          }
        });
      }
    });

    return {
      allCount: totalCount,
      brandList: Array.from(brandMap.entries()),
    };
  };

  const { brandList, allCount } = getBrandsWithCounts(
    products?.categories || [],
    selectedCategoryName
  );
  useEffect(() => {
    let allProducts = [];

    products?.categories.forEach((category) => {
      if (
        !selectedCategoryName ||
        selectedCategoryName === "ALL" ||
        category.categoryName === selectedCategoryName
      ) {
        category.brands.forEach((brand) => {
          allProducts.push(...brand.products);
        });
      }
    });

    setProductsData(allProducts);
  }, [products, selectedCategoryName]);

  useEffect(() => {
    if (products) {
      const all = [];

      products.categories.forEach((cat) => {
        cat.brands.forEach((brand) => {
          brand.products.forEach((prod) => {
            all.push({
              ...prod,
              categoryName: cat.categoryName,
              brandName: brand.brandName,
            });
          });
        });
      });

      setAllProducts(all);
      setProductsData(all);
    }
  }, [products]);

  const tag = 'Branches'

  useEffect(() => {
    const getAnnouncement = async () => {
      try {
        const response = await axios.get(getAnnouncebyTag, {
          params: {
            tag: tag,
          },
        });
        if (
          response.data &&
          Array.isArray(response.data.announcements) &&
          response.data.announcements.length > 0
        ) {
          setAnnouncementMessage(response.data.announcements);
        }
      } catch (error) {
        console.error("Error fetching announcement:", error);
      }
    };
    getAnnouncement();
  }, [tag]);

  const handleSearch = (e) => {
    setShowbrand(false);
    const value = e.target.value.toLowerCase();
    setSearchQuery(value);

    const filtered = allProducts.filter((item) => {
      return (
        item.categoryName?.toLowerCase().includes(value) ||
        item.brandName?.toLowerCase().includes(value) ||
        item.productName?.toLowerCase().includes(value) ||
        item.price?.toString().includes(value) ||
        item.discountPrice?.toString().includes(value)
      );
    });

    setProductsData(filtered);
  };

  useEffect(() => {
    imgageRefs.current = {};
  }, [productsData]);

  return (
    <div>
      <Header />
      <div className="accessories-main-container">
        <img src={dotimg} alt="" className="dot-img" />
        <div className="our-own-text">OUR OWN</div>
        <div className="accessories-center-text">
          <div className="text-description">
            Appeals to serious athletes and enthusiasts
          </div>
          <div className="accessories-product-text">PRODUCT</div>
          <div
            className="scroll-text-left"
            style={{ position: "absolute", left: "20px", top: "300px" }}
          >
            <div
              style={{
                borderRight: "2px solid white",
                paddingBottom: "100px",
                margin: "0px 0px 0px 7px",
                writingMode: "vertical-lr",
                height: "100px",
              }}
            ></div>
            <div
              style={{
                writingMode: "sideways-lr",
                fontSize: "0.7rem",
                color: "white",
                letterSpacing: "2px",
                marginTop: "10px",
              }}
            >
              Scroll Down
            </div>
          </div>

          <div
            className="scroll-text-right"
            style={{ position: "absolute", right: "20px", top: "300px" }}
          >
            <div
              style={{
                writingMode: "sideways-lr",
                fontSize: "0.7rem",
                color: "white",
                letterSpacing: "2px",
              }}
            >
              Scroll Down
            </div>
            <div
              style={{
                borderRight: "2px solid white",
                paddingBottom: "20px",
                margin: "10px 0px 0px 7px",
                writingMode: "vertical-lr",
                height: "100px",
              }}
            ></div>
          </div>
        </div>

        {announcementMessage.length > 0 && (
          <Marquee gradient={false} speed={80} pauseOnHover={true} >
          {announcementMessage
            .filter((announce) => announce.status === "active")
            .map((announce, index) => (
              <span className="marquee">{announce.message}</span>
            ))}
        </Marquee>
        )}
      </div>

      <div className="accessories-running-carousel">
        <div className="logo-items">
          <div className="item-name">FOOTBALL</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">BADMINTON</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">CRICKET</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">VOLLEYBALL</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">CARROMS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">SWIMMING</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">TENNIS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">APPARELS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">FITNESS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
        </div>
        <div className="logo-items">
          <div className="item-name">FOOTBALL</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">BADMINTON</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">CRICKET</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">VOLLEYBALL</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">CARROMS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">SWIMMING</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">TENNIS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">APPARELS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
          <div className="item-name">FITNESS</div>{" "}
          <div style={{ color: "orange" }}>
            <LuDot />
          </div>
        </div>
      </div>

      <div className="accessories">
        <div
          className="accessories-header"
          style={{ display: "flex", gap: "10%", alignItems: "center" }}
        >
          <Dropdown
            className="accessories-dropdown"
            value={selectProduct}
            onChange={(e) => setSelectedProduct(e.value)}
            options={items}
            optionLabel="name"
            placeholder="ALL"
            dropdownIcon={
              <IoMdArrowDropdown size={35} className="accessories-down-arrow" />
            }
          />
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="category-title">
              {selectedCategoryName === "ALL"
                ? "ALL PRODUCT"
                : `ALL ${selectedCategoryName.toUpperCase()} PRODUCT`}
            </div>

            <IconField
              className="search-wrapper"
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                width: "270px",
              }}
            >
              <InputIcon
                style={{
                  backgroundColor: "black",
                  padding: "17px",
                  color: "white",
                  top: "50%",
                  right: 0,
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "50px",
                }}
                className="pi pi-search"
              >
                {" "}
              </InputIcon>
              <InputText
                style={{
                  borderRadius: "0px",
                  width: "100%",
                  padding: "11px",
                  height: "50px",
                  paddingRight: "50px",
                }}
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
            </IconField>
          </div>
        </div>
        <div
          className="responsive-accessories-maincontainer"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="accessories-left ">
            <div
              className="accessories-items"
              style={{ paddingBottom: "25px" }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <svg
                  strokeWidth="69"
                  height="30"
                  viewBox="0 0 69 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="48" height="40" fill="black" />
                  <rect
                    x="33.5"
                    y="14.5"
                    width="34"
                    height="12"
                    fill="black"
                    stroke="white"
                    strokeWidth="3"
                  />
                </svg>
                <div style={{ fontSize: "1.5rem" }}>ALL({allCount})</div>
              </div>
              <div className="accessories-item">
                {brandList.map(([brandName, count]) => (
                  <div
                    key={brandName}
                    style={{ cursor: "pointer" }}
                    onClick={() => onShowbrand(brandName)}
                  >
                    {brandName} ({count})
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="responsive-accessories">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="responsive-header">
                {" "}
                {selectedCategoryName === "ALL"
                  ? "ALL PRODUCT"
                  : `ALL ${selectedCategoryName.toUpperCase()} PRODUCT`}
              </div>
            </div>

            <div
              className="dropdown-searchbar"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="product-drop-down">
                <Dropdown
                  className="accessories-dropdown"
                  value={selectProduct}
                  onChange={(e) => setSelectedProduct(e.value)}
                  options={items}
                  optionLabel="name"
                  placeholder="ALL"
                />
                <IoMdArrowDropdown
                  size={35}
                  className="responsive-accessories-down-arrow"
                  style={{ marginLeft: "-40px", color: "gray" }}
                />
              </div>
              <div
                className="search-bar"
                style={{ display: "flex", width: "300px" }}
              >
                <IconField
                  className="search-wrapper"
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    width: "270px",
                  }}
                >
                  <InputIcon
                    style={{
                      backgroundColor: "black",
                      padding: "17px",
                      color: "white",
                      top: "50%",
                      right: 0,
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "50px",
                    }}
                    className="pi pi-search"
                  >
                    {" "}
                  </InputIcon>
                  <InputText
                    style={{
                      borderRadius: "0px",
                      width: "100%",
                      padding: "11px",
                      height: "50px",
                      paddingRight: "50px",
                    }}
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="input-txt"
                  />
                </IconField>
              </div>
            </div>
            <div className="accessories-item">

              {brandList.map(([brandName, count]) => (
                <div
                  key={brandName}
                  style={{ cursor: "pointer" }}
                  onClick={() => onShowbrand(brandName)}
                  className={`brand-pill ${
                    selectedBrand === brandName ? "selected" : ""
                  }`}
                >
                  {brandName} ({count})
                </div>
              ))}
            </div>
          </div>
          {showBrand && (
            <div
              className="brand-name"
              style={{
                backgroundColor: "#222222",
                display: "flex",
                gap: "5px",
                alignItems: "center",
                height: "50px",
                justifyContent: "space-between",
                padding: "0 10px",
                position: "absolute",
                left: "350px",
                marginTop: "50px",
              }}
            >
              <span style={{ color: "white", cursor: "pointer" }}>
                {selectedBrand}
              </span>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onShowbrand("ALL");
                  setShowbrand(false);
                }}
              >
                <IoCloseOutline size={20} color="white" />
              </div>
            </div>
          )}

          <div className="products-container" ref={productContainerRef}>
            {productsData.slice(first, first + rows).map((product, index) => (
              <div>
                <div
                  key={product.id || index}
                  className="product-card"
                  style={{
                    backgroundColor: product.isOutOfStock
                      ? "#0f0f0f33"
                      : bgColorCycle[index % bgColorCycle.length],
                    marginTop: "0px",
                  }}
                >
                  <div className="product-img">
                    <img
                      ref={(el) => (imgageRefs.current[index] = el)}
                      width={400}
                      height={350}
                      src={product.imageUrl}
                      alt={product.productName}
                      className={product.isOutOfStock ? "out-of-stock" : ""}
                    />
                  </div>
                </div>
                <div
                  className="product-details"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ textAlign: "left" }}>
                    <p className="brand">{product.productName}</p>
                  </div>
                  <div>
                    <p className="price">
                      <span className="text-gray-300 text-lg mr-2">VAT included</span> <span className="text-[24px] mr-1">OMR</span>
                      <span>
                      {product.discountPercentage > 0
                        ? product.discountPrice.toFixed(2)
                        : product.price.toFixed(2)}
                        </span>
                    </p>
                    <div className="flex mt-2 ml-2">
                      <span className="text-[24px] mt-1  mr-1 text-gray-500">OMR</span>
                      {product.discountPercentage > 0 && (
                        <p className="old-price">
                          <span
                            style={{
                              textDecoration: "line-through",
                              paddingRight: "5px",
                            }}
                            className="text-gray-500"
                          >
                            {product.price.toFixed(2)}
                          </span>{" "}
                          <span className="discount">
                            {product.discountPercentage}% Off
                          </span>
                        </p>
                      )}
                      {product.isOnSale && (
                        <div style={{ color: "gray" }}>ONSALE</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Paginator
        className="accessories-paginator"
        style={{ paddingBottom: "50px" }}
        first={first}
        rows={rows}
        totalRecords={productsData.length}
        onPageChange={(e) => {
          window.scrollTo({ top: 800, behavior: "instant" });
          setFirst(e.first);
          setRows(e.rows);
        }}
        pageLinkSize={3}
      />
      <BookSlot />
      <Footer />
    </div>
  );
};

export default Accessories;
